<template>
  <div class="home">
    <hkkfPage/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import hkkfPage from '@/components/hkkfPage.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'hkkfView',
  components: {
    hkkfPage,
  },
});
</script>
